import {View} from 'react-native';
import {Divider} from 'react-native-paper';
import sy from '~/styles';
import {Modal, Pressable, Text, PrimaryButton} from '~/components/controls';
import Format from '~/lib/format';
import CloseIcon from '~/images/md-icons/close/materialicons/24px.svg';
import EuroSymbolIcon from '~/images/md-icons/euro_symbol/materialicons/24px.svg';
export const DetailsFrame = ({
  onDismiss,
  showUnitPrice,
  setShowUnitPrice,
  total_amount,
  children,
}) => (
  <Modal visible={true} onDismiss={onDismiss}>
    <View style={[{height: 64}, sy['flex-row'], sy['items-center']]}>
      <Pressable style={[sy['p-4']]} onPress={onDismiss}>
        <CloseIcon fill="#4a4a49" />
      </Pressable>

      <View style={[sy['flex-1'], sy['items-center']]}>
        <Text style={[sy.smallPlus]}>Details opdracht</Text>
      </View>
      <Pressable
        style={[sy['p-4']]}
        onPress={() => setShowUnitPrice((prevState) => !prevState)}>
        <EuroSymbolIcon
          fill="#4a4a49"
          style={{opacity: showUnitPrice ? 1 : 0.38}}
        />
      </Pressable>
    </View>
    {children}
    <Divider style={sy['bg-gray88']} />
    <View
      style={[
        sy['flex-row'],
        sy['items-center'],
        sy['justify-between'],
        sy['p-4'],
      ]}>
      <Text style={sy.mediumPlus}>{Format.price(total_amount)}</Text>
      <PrimaryButton onPress={onDismiss}>Sluiten</PrimaryButton>
    </View>
  </Modal>
);
export const TaskSecondaryAmount = ({
  showUnitPrice,
  amount,
  amount_diff,
  task,
  perItem,
}) =>
  (() => {
    if (showUnitPrice) {
      return (
        <Text style={[sy.smallRegular, sy['text-lightgray']]}>
          {Format.price(
            Format.round(
              amount / (perItem || task.duration === 0 ? 1 : task.duration),
            ),
          )}
          &nbsp;
          {perItem ? <>p/s</> : <>p/u</>}
        </Text>
      );
    }

    if (Format.round(amount_diff) !== 0) {
      return (
        <Text
          style={[sy.smallRegular, sy['text-lightgray'], sy['line-through']]}>
          {Format.price(amount - amount_diff)}
        </Text>
      );
    }

    return null;
  })();
